export const affiliate_survey = {
  enabled: true,
  title: "Sua opinião é importante",
  message: `
    <b>ATENÇÃO!!!</b><br/>
    
    Prezados afiliados,
    Com o objetivo de atender de forma ainda mais eficiente às demandas de cada emissora, lançamos esta nova pesquisa. Periodicamente, realizaremos iniciativas como esta, buscando manter constante alinhamento com as necessidades editoriais, jornalísticas e artísticas de nossos parceiros.
    <br/><br/>A participação de todos é fundamental para que possamos aprimorar continuamente nossos sistemas e conteúdos.
    Contamos com a colaboração de vocês!
    <br/><br/>
    <b>ATENÇÃO!</b><br/> 
    O PREENCHIMENTO É OBRIGATÓRIO E DEVE SER FEITO PELO RESPONSÁVEL POR CADA EMISSORA. SE VOCÊ NÃO É O RESPONSÁVEL, POR FAVOR, DIRECIONE O QUESTIONÁRIO A ELE (A) E PEÇA QUE RESPONDA. 
    <br/><br/> 
    <i>Caso voce precisa de suporte para preenchimento deste formulário agende um horário com a nossa equipe pelo Whastapp <a href="https://wa.me/5531998188168" target="_blank">(31) 99818-8168</a>.</i>

`,
  button_label: "Responder pesquisa",
  url: "https://docs.google.com/forms/d/e/1FAIpQLScH6L0u3ppo3FJbI5-M0XmJurZkbBHj90fDPJleUQZxXY44gw/viewform?usp=header",
};
